import { Globe2 } from "lucide-react";
import { LANGS, CURRENCIES, usePrefs } from "@/lib/prefs";

export default function PrefsSwitcher({ className = "" }) {
  const { lang, setLang, currency, setCurrency } = usePrefs();
  const cls = "bg-transparent text-xs text-slate-300 border border-amber-500/30 rounded-full px-2 py-1.5 focus:outline-none focus:border-amber-400";
  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="prefs-switcher">
      <Globe2 className="w-4 h-4 text-amber-400" />
      <select value={lang} onChange={(e) => setLang(e.target.value)} className={cls} data-testid="language-select" aria-label="Language">
        {LANGS.map((l) => <option key={l.code} value={l.code} className="bg-[#11131A]">{l.label}</option>)}
      </select>
      <select value={currency} onChange={(e) => setCurrency(e.target.value)} className={cls} data-testid="currency-select" aria-label="Currency">
        {CURRENCIES.map((c) => <option key={c} value={c} className="bg-[#11131A]">{c}</option>)}
      </select>
    </div>
  );
}
